<template>
  <div class="media-marketing-header" :class="{
    desktop: isDesktop,
    mobile: isMobile,
  }">
    <div class="header-content">
      <h1 class="title">
        數位公關 X 網路行銷<br />
        美業 Visages 口碑媒體
      </h1>
      <h2 class="sub-title">
        協助美業網路行銷成為指標性商家<br />
        創造品牌曝光與好感度
      </h2>
      <button @click="toForm($route.name)">聯絡我們</button>
    </div>
  </div>
</template>

<script setup>
import { useWindowSize } from '@vueuse/core'
import { computed } from '@vue/reactivity'
import { toForm } from '@/utils/helper'
const { width } = useWindowSize()

const isDesktop = computed(() => {
  return width.value > 768
})
const isMobile = computed(() => {
  return width.value < 768
})
</script>

<style scoped lang="postcss">
.media-marketing-header {
  @apply h-[611px] w-full;
}

.desktop {
  background-image: url('@/assets/header/media-marketing.png');
}

.mobile {
  @apply h-[408px];
  background-image: url('@/assets/header/mobile/media-marketing.png');
}

.header-content {
  @apply text-left text-primary-100 px-[136px] pt-[120px];
  @apply <ipad: (px-[20px] pt-[32px]);
}

button {
  @apply bg-secondary-100 text-white rounded-full;
  @apply px-[68px] py-[15px];
  @apply <ipad: (px-[20px] py-[6px] text-[16px] mt-[150px]);
  @apply <tablet: (mt-[200px]);
}

.title {
  @apply m-0 font-bold text-[60px] leading-[86.88px] tracking-[2px] mb-[25px];
  @apply <ipad: (text-[30px]);
  @apply <tablet: (text-[26px] mb-[20px]);
}

.sub-title {
  @apply font-medium text-[27.16px] leading-[40px] tracking-[1.51px] mb-[42px];
  @apply <ipad: (text-[16px]);
  @apply <tablet: (text-[12px] mb-[20px]);
}
</style>
